import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthLayout } from '../../components/layouts/AuthLayout';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function RegisterPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'mobile' | 'otp' | 'profile'>('mobile');
  const [isLoading, setIsLoading] = useState(false);
  const handleSendOtp = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setStep('otp');
    }, 1000);
  };
  const handleVerifyOtp = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setStep('profile');
    }, 1000);
  };
  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      navigate('/dashboard');
    }, 1500);
  };
  return <AuthLayout title="ثبت نام در سامانه" subtitle="اطلاعات خود را برای ایجاد حساب وارد کنید" data-id="element-739">
      {step === 'mobile' && <form onSubmit={handleSendOtp} className="space-y-6" data-id="element-740">
          <Input label="شماره موبایل" placeholder="09123456789" required type="tel" dir="ltr" className="text-left" data-id="element-741" />
          <Button type="submit" className="w-full" isLoading={isLoading} data-id="element-742">
            دریافت کد تایید
          </Button>
          <div className="text-center text-sm" data-id="element-743">
            قبلاً ثبت نام کرده‌اید؟{' '}
            <Link to="/" className="text-primary hover:underline font-medium" data-id="element-744">
              وارد شوید
            </Link>
          </div>
        </form>}

      {step === 'otp' && <form onSubmit={handleVerifyOtp} className="space-y-6" data-id="element-745">
          <Input label="کد تایید پیامک شده" placeholder="12345" required className="text-center tracking-widest text-lg" maxLength={5} data-id="element-746" />
          <Button type="submit" className="w-full" isLoading={isLoading} data-id="element-747">
            تایید و ادامه
          </Button>
        </form>}

      {step === 'profile' && <form onSubmit={handleRegister} className="space-y-4" data-id="element-748">
          <div className="grid grid-cols-2 gap-4" data-id="element-749">
            <Input label="نام" required data-id="element-750" />
            <Input label="نام خانوادگی" required data-id="element-751" />
          </div>
          <Input label="کد ملی" required maxLength={10} data-id="element-752" />
          <Input label="تاریخ تولد" placeholder="1370/01/01" required data-id="element-753" />
          <Input label="آدرس ایمیل (اختیاری)" type="email" dir="ltr" className="text-left" data-id="element-754" />

          <Button type="submit" className="w-full mt-6" isLoading={isLoading} data-id="element-755">
            تکمیل ثبت نام
          </Button>
        </form>}
    </AuthLayout>;
}